// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { ITranslationTable } from '../EnumClass';

export const name: ITranslationTable = {
  /* eslint-disable max-len */
  en: (t, data?, options?) => t('enum.language.en.name', data, options),
  es: (t, data?, options?) => t('enum.language.es.name', data, options),
  id: (t, data?, options?) => t('enum.language.id.name', data, options),
  it: (t, data?, options?) => t('enum.language.it.name', data, options),
  ja: (t, data?, options?) => t('enum.language.ja.name', data, options),
  ko: (t, data?, options?) => t('enum.language.ko.name', data, options),
  'pt-BR': (t, data?, options?) => t('enum.language.pt-br.name', data, options),
  ru: (t, data?, options?) => t('enum.language.ru.name', data, options),
  th: (t, data?, options?) => t('enum.language.th.name', data, options),
  tlh: (t, data?, options?) => t('enum.language.tlh.name', data, options),
  tr: (t, data?, options?) => t('enum.language.tr.name', data, options),
  vi: (t, data?, options?) => t('enum.language.vi.name', data, options),
  'zh-Hans': (t, data?, options?) => t('enum.language.zh-hans.name', data, options),
  'zh-Hant': (t, data?, options?) => t('enum.language.zh-hant.name', data, options),
  /* eslint-enable max-len */
};
